import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CdbjjPage from "../pages/cdbjj/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/powerhouse" replace />,
  },
  {
    path: "/powerhouse",
    element: <Home />,
  },
  {
    path: "/cdbjj",
    element: <CdbjjPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
